var styles = {"article":"CenterModalWrapper-module_article__Wo1lu","modal-body":"CenterModalWrapper-module_modal-body__oj4Y0"};

export { styles as default };
